module.exports = __webpack_public_path__ + "static/media/barratt.aaa5d0e2.svg";